import { ChangeEvent, useEffect, useState } from "react"

import { useTranslation } from "react-i18next"

import { NavButton } from "../buttons/NavButton"

type TablePaginationProps = {
  page: number
  totalPages: number
  onJump: (jumpTo: number) => void
}
export const TablePagination = ({ page, totalPages, onJump }: TablePaginationProps) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const [jumpTo, setJumpTo] = useState<string | number>(page)

  useEffect(() => {
    setJumpTo(page)
  }, [page])

  return (
    <div className="w-full p-2 flex items-center justify-between">
      <div className="w-full flex items-center justify-between">
        <div className="flex items-center text-sm">
          <div className="text-sm pr-8 text-black dark:text-white">{t("table.pagination", { page: page, total: totalPages })}</div>

          <input
            type="number"
            className="input input-bordered input-sm w-[100px] !pr-1 border border-[rgba(139,92,246,0.4)] bg-transparent dark:border-[rgba(255,255,255,0.15)] text-black dark:text-white"
            min={1}
            value={jumpTo}
            onChange={(ev: ChangeEvent<HTMLInputElement>) => setJumpTo(ev.target.value)}
          />
          <button
            className="btn btn-sm btn-primary ml-2 bg-transparent text-[rgba(169,78,206,1)] border-[rgba(169,78,206,0.8)] hover:bg-[rgba(169,78,206,0.8)] hover:border-transparent dark:text-white hover:text-white"
            onClick={() => onJump(Math.min(Number(jumpTo) || 1, totalPages))}
          >
            GO
          </button>
        </div>
        <div className="flex justify-center items-center gap-4">
          {page > 1 && (
            <NavButton
              className="text-[rgba(169,78,206,1)] border-[rgba(169,78,206,0.8)] hover:bg-[rgba(169,78,206,0.8)] hover:border-transparent dark:text-white hover:text-white"
              text={t("common.previous")}
              handler={() => onJump(page - 1)}
            />
          )}
          {page < totalPages && (
            <NavButton
              className="text-[rgba(169,78,206,1)] border-[rgba(169,78,206,0.8)] hover:bg-[rgba(169,78,206,0.8)] hover:border-transparent dark:text-white hover:text-white"
              text={t("common.next")}
              handler={() => onJump(page + 1)}
            />
          )}
        </div>
      </div>
    </div>
  )
}
